module.exports = __webpack_public_path__ + "img/04.8413fbc4.png";